import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b06c675c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b06c675c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionMain: require('/opt/airport.kg/src/components/section/main.vue').default,SectionTablo: require('/opt/airport.kg/src/components/section/tablo.vue').default,SectionServices: require('/opt/airport.kg/src/components/section/services.vue').default,SectionOffers: require('/opt/airport.kg/src/components/section/offers.vue').default,SectionNews: require('/opt/airport.kg/src/components/section/news.vue').default,BaseFooter: require('/opt/airport.kg/src/components/base/footer.vue').default})
